<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon"><md-icon>help</md-icon></div>
          <h4 class="title">FAQ — Page Content</h4>
        </md-card-header>

        <md-card-content v-if="loading"><p>Loading...</p></md-card-content>
        <md-card-content v-else>

          <div class="cms-tabs">
            <button v-for="tab in tabs" :key="tab.key"
              :class="['tab-btn', { active: activeTab === tab.key }]"
              @click="activeTab = tab.key">{{ tab.label }}</button>
          </div>

          <!-- Hero -->
          <div v-if="activeTab === 'hero'" class="cms-section">
            <h5 class="section-label">Hero Section</h5>
            <md-field><label>Title</label><md-input v-model="form.hero.title" /></md-field>
            <md-field><label>Subtitle</label><md-input v-model="form.hero.subtitle" /></md-field>
          </div>

          <!-- CTA -->
          <div v-if="activeTab === 'cta'" class="cms-section">
            <h5 class="section-label">Bottom CTA Section</h5>
            <md-field><label>Title</label><md-input v-model="form.cta.title" /></md-field>
            <md-field><label>Text</label><md-input v-model="form.cta.text" /></md-field>
            <md-field><label>Phone Number</label><md-input v-model="form.cta.phone" /></md-field>
          </div>

          <!-- Categories & Questions -->
          <div v-if="activeTab === 'faqs'" class="cms-section">
            <h5 class="section-label">FAQ Categories & Questions</h5>

            <div v-for="(cat, ci) in form.categories" :key="ci" class="array-card">
              <div class="cat-header">
                <div class="md-layout md-gutter">
                  <div class="md-layout-item md-size-25">
                    <md-field><label>Category ID</label><md-input v-model="cat.id" placeholder="orders" /></md-field>
                  </div>
                  <div class="md-layout-item md-size-35">
                    <md-field><label>Category Name</label><md-input v-model="cat.name" placeholder="Orders & Payment" /></md-field>
                  </div>
                  <div class="md-layout-item md-size-30">
                    <md-field><label>Icon Class</label><md-input v-model="cat.icon" placeholder="fas fa-shopping-cart" /></md-field>
                  </div>
                  <div class="md-layout-item md-size-10" style="display:flex; align-items:center;">
                    <md-button class="md-icon-button md-danger" @click="form.categories.splice(ci, 1)">
                      <md-icon>delete</md-icon>
                    </md-button>
                  </div>
                </div>
              </div>

              <!-- Questions in this category -->
              <div class="questions-block">
                <p class="questions-label">Questions ({{ cat.questions.length }})</p>
                <div v-for="(q, qi) in cat.questions" :key="qi" class="question-row">
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-45">
                      <md-field><label>Question</label><md-input v-model="q.question" /></md-field>
                    </div>
                    <div class="md-layout-item md-size-50">
                      <md-field><label>Answer</label><md-textarea v-model="q.answer" /></md-field>
                    </div>
                    <div class="md-layout-item md-size-5" style="display:flex; align-items:center;">
                      <md-button class="md-icon-button md-danger md-sm" @click="cat.questions.splice(qi, 1)">
                        <md-icon>close</md-icon>
                      </md-button>
                    </div>
                  </div>
                </div>
                <md-button class="md-primary md-sm" @click="cat.questions.push({ question: '', answer: '' })">
                  + Add Question
                </md-button>
              </div>
            </div>

            <md-button class="md-success md-sm" @click="form.categories.push({ id: '', name: '', icon: '', questions: [] })">
              + Add Category
            </md-button>
          </div>

        </md-card-content>
        <md-card-actions md-alignment="left">
          <md-button class="md-success" :disabled="isSaving" @click="save">
            {{ isSaving ? 'Saving...' : 'Save Changes' }}
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import CmsService from "../../../services/CmsService";
export default {
  name: "FaqPageCms",
  data() {
    return {
      loading: true, isSaving: false, activeTab: "hero",
      tabs: [
        { key: "hero", label: "Hero" },
        { key: "faqs", label: "FAQ Categories" },
        { key: "cta",  label: "CTA" },
      ],
      form: {
        hero:       { title: "", subtitle: "" },
        cta:        { title: "", text: "", phone: "" },
        categories: [],
      },
    };
  },
  methods: {
    load() {
      CmsService.getPage("faq").then((r) => {
        const s = r.data.data.sections;
        this.form.hero       = s.hero       || this.form.hero;
        this.form.cta        = s.cta        || this.form.cta;
        this.form.categories = s.categories || [];
        this.loading = false;
      }).catch(() => { this.loading = false; });
    },
    save() {
      this.isSaving = true;
      CmsService.updatePage("faq", { sections: this.form })
        .then(() => { this.$toast.success("FAQ page saved!"); this.isSaving = false; })
        .catch(() => { this.$toast.error("Save failed."); this.isSaving = false; });
    },
  },
  beforeMount() { this.load(); },
};
</script>

<style scoped>
.cms-tabs { display:flex; gap:8px; flex-wrap:wrap; border-bottom:2px solid #e2e8f0; margin-bottom:24px; }
.tab-btn { padding:10px 18px; border:none; background:transparent; font-size:14px; font-weight:500; color:#718096; cursor:pointer; border-bottom:3px solid transparent; margin-bottom:-2px; }
.tab-btn.active { color:#4caf50; border-bottom-color:#4caf50; font-weight:600; }
.cms-section { padding:8px 0 16px; }
.section-label { font-size:15px; font-weight:600; color:#2d3748; margin-bottom:20px; }
.array-card { background:#f8fafb; border:1px solid #e2e8f0; border-radius:10px; padding:20px; margin-bottom:16px; }
.questions-block { margin-top:12px; padding-top:12px; border-top:1px solid #e2e8f0; }
.questions-label { font-size:13px; font-weight:600; color:#718096; margin-bottom:10px; }
.question-row { background:white; border:1px solid #e2e8f0; border-radius:8px; padding:12px; margin-bottom:8px; }
.cat-header { margin-bottom:8px; }
</style>